import { useEffect, useState } from "react";
import Input from "../../../../ui/molecules/input";
import { SelectCustom } from "../../../../ui/molecules/select";
import { OptionType } from "../../../../utils";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { GetHeadQuarter } from "../../../sot/slice";
import Button from "../../../../ui/molecules/button";
import TextArea from "../../../../ui/molecules/textArea";
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox";
import { ManipulationDetailCreation, resetManipulationDetailRequest, setMDCreationCompanyName, setMDCreationContact, setMDCreationCoordinates, setMDCreationGGGNGLN, setMDCreationGGNotificationId, setMDCreationHeadquarter, setMDCreationIsCertified, setMDCreationParallelProperty, setMDCreationProducts, setMDCreationThirdPartyPackaging, setMDCreationVatOrFiscalCode } from "./slice";

interface Props {
    close: () => void
}

export function ManipulationPopup(props: Props) {
    const dispatch = useAppDispatch()
    const sotState = useAppSelector(state => state.headQuarter)
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const manipulationDetailState = useAppSelector(state => state.ggManipulationDetail)
    const [headquarters, setHeadquarters] = useState<OptionType[]>([])
    const [thirdParty, setThirdParty] = useState<boolean>(false)
    const [isCertified, setIsCertified] = useState<boolean>(false)
    const [parallelProperty, setParallelProperty] = useState<boolean>(false)

    useEffect(() => {
        dispatch(resetManipulationDetailRequest())
        dispatch(setMDCreationGGNotificationId(ggNotificationState.ggNotificationIdToUpdate))
        dispatch(GetHeadQuarter({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        if (sotState.responseHeadQuarterStatus === 'successfully' &&
            sotState.responseHeadQuarter !== undefined
        ) {
            const data = sotState.responseHeadQuarter.data.map(hq => {
                return {
                    value: hq.id,
                    label: hq.code
                } as OptionType
            })

            setHeadquarters(data)
        }
    }, [sotState.responseHeadQuarterStatus])

    useEffect(() => {
        if(manipulationDetailState.manipulationDetailCreationStatus === 'successfully') {
            props.close()
        }
    }, [manipulationDetailState.manipulationDetailCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Ragione Sociale'}
                            placeholder="Specifica ragione sociale..."
                            value={manipulationDetailState.manipulationDetailCreationRequest.companyName}
                            onChangeText={(text) => dispatch(setMDCreationCompanyName(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <div className='text-left input-label'>
                            Sede
                        </div>
                        <SelectCustom
                            placeholder='Seleziona sede...'
                            value={manipulationDetailState.manipulationDetailCreationRequest.headQuarter}
                            options={headquarters}
                            onChange={(value) => dispatch(setMDCreationHeadquarter(value))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Contatti'}
                            placeholder="Specifica contatti..."
                            value={manipulationDetailState.manipulationDetailCreationRequest.contact}
                            onChangeText={(text) => dispatch(setMDCreationContact(text))}
                        />
                    </div>
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'GGN/GLN'}
                            placeholder="Specifica GGN/GLN..."
                            value={manipulationDetailState.manipulationDetailCreationRequest.ggnGln}
                            onChangeText={(text) => dispatch(setMDCreationGGGNGLN(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'P. IVA / C.F.'}
                            placeholder="Specifica P.IVA / C.F..."
                            value={manipulationDetailState.manipulationDetailCreationRequest.vatOrFiscalCode}
                            onChangeText={(text) => dispatch(setMDCreationVatOrFiscalCode(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Coordinate geografiche'}
                            placeholder="Specifica coordinate geografiche..."
                            value={manipulationDetailState.manipulationDetailCreationRequest.coordinates}
                            onChangeText={(text) => dispatch(setMDCreationCoordinates(text))}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '48px', alignItems: 'flex-end' }}>
                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left input-label'>
                            Confeziona gli stessi prodotti ad altri produttori/organizzazioni?
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={thirdParty}
                            setChecked={(value) => {
                                dispatch(setMDCreationThirdPartyPackaging(value))
                                setThirdParty(value)
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left input-label'>
                            Certificato
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={isCertified}
                            setChecked={(value) => {
                                dispatch(setMDCreationIsCertified(value))
                                setIsCertified(value)
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left input-label'>
                            Proprietà Parallela
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={parallelProperty}
                            setChecked={(value) => {
                                dispatch(setMDCreationParallelProperty(value))
                                setParallelProperty(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-3">
                    <div className='text-left input-label'>
                        Prodotto/i
                    </div>
                    <TextArea 
                        value={manipulationDetailState.manipulationDetailCreationRequest.products}
                        onChangeText={(text) => dispatch(setMDCreationProducts(text))}
                        />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        dispatch(resetManipulationDetailRequest())
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(ManipulationDetailCreation(manipulationDetailState.manipulationDetailCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}